import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Col, Container, Row} from "@pg-design/grid-module";
import {backgroundColor, borderRadius, onDesktop, p, textAlign, w100} from "@pg-design/helpers-css";
import {flex, flexAbsoluteCenter} from "@pg-design/helpers-css-strings";
import {BrandBuildingsIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {creditOfferLeadTracking, CreditTrackingActionType} from "../../tracking/credit_check_offers_racking";

interface IProps {
    min: number;
    max: number;
    filterPrice: number;
}

export const CreditOfferLeadBox = (props: IProps) => {
    const {min, max, filterPrice} = props;
    const theme = useTheme();

    const userPreferences = useSelector((state: IRPStore) => state.user.preferences);
    const userPreferencesFilters = userPreferences?.data?.filters;

    const iconProps = {size: "15", wrapperColor: theme.colors.primary, wrapperSize: "15.5"};

    const clickHandler = () => {
        const url = appendQueryString(rpAppLink.propertyConfigurator(), {
            ...userPreferencesFilters,
            ...(userPreferencesFilters?.region ? {search: userPreferencesFilters?.region} : {}),
            price_1: filterPrice
        });

        creditOfferLeadTracking(CreditTrackingActionType.CLICK);

        window.location.href = url;
    };

    useEffect(() => {
        creditOfferLeadTracking(CreditTrackingActionType.VIEW);
    }, []);

    return (
        <Container as="section" css={boxWrapper}>
            <Row css={rowStyle}>
                <Col md={9}>
                    <Row css={boxContent}>
                        <Col md={3} lg={3} css={iconCol}>
                            <BrandBuildingsIcon {...iconProps} />
                        </Col>
                        <Col>
                            <Text variant="body_copy_1" css={[textAligment]}>
                                RATA
                            </Text>
                            <Text variant="headline_2" css={[textAligment, priceRange]} as="p">
                                {min} - {max} zł
                            </Text>
                            <Text variant="headline_6" css={[textAligment, copyStyle]} as="p">
                                Sprawdź nieruchomości, które mieszczą się w Twojej estymowanej racie kredytu
                            </Text>
                        </Col>
                    </Row>
                </Col>
                <Col md={3} css={colCta}>
                    <Button css={boxCta} variant="filled_primary" onClick={clickHandler}>
                        Zobacz Oferty
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

const priceRange = (theme: Theme) => css`
    background: ${theme.colors.primary};
    width: fit-content;
    margin: 0 auto;
    @media (min-width: ${theme.breakpoints.md}) {
        margin: 0;
    }
`;

const copyStyle = (theme: Theme) => css`
    max-width: 415px;
    margin: 2.4rem auto;
    @media (min-width: ${theme.breakpoints.md}) {
        margin: 2.4rem 0;
    }
`;

const textAligment = css`
    ${textAlign("center")};
    ${onDesktop(textAlign("left"))};
`;

const colCta = css`
    display: flex;
    align-items: center;
    justify-content: end;
`;

const boxCta = (theme: Theme) => css`
    display: block;
    margin: 2rem auto;
    width: 100%;
    @media (min-width: ${theme.breakpoints.md}) {
        width: auto;
        margin: 0;
    }
`;

const boxWrapper = (theme: Theme) => css`
    ${backgroundColor(theme.colors.success)};
    ${w100};
    ${p(2)};
    ${borderRadius(2)};
    box-shadow: ${theme.shadow["2"]};
    ${onDesktop(p(3))};
`;

const iconCol = (theme: Theme) => css`
    ${flexAbsoluteCenter}
    ${p(2)};
    @media (min-width: ${theme.breakpoints.md}) {
        ${flex()}
    }
`;

const rowStyle = (theme: Theme) => css`
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;
const boxContent = (theme: Theme) => css`
    ${flex("center", "space-between")};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;
import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {Col, Container, Row} from "@pg-design/grid-module";
import {backgroundColor, borderRadius, onDesktop, p, textAlign, w100} from "@pg-design/helpers-css";
import {flex, flexAbsoluteCenter} from "@pg-design/helpers-css-strings";
import {BrandBuildingsIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";
import {appendQueryString} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../../app/rp_reducer";
import {creditOfferLeadTracking, CreditTrackingActionType} from "../../tracking/credit_check_offers_racking";

interface IProps {
    min: number;
    max: number;
    filterPrice: number;
}

export const CreditOfferLeadBox = (props: IProps) => {
    const {min, max, filterPrice} = props;
    const theme = useTheme();

    const userPreferences = useSelector((state: IRPStore) => state.user.preferences);
    const userPreferencesFilters = userPreferences?.data?.filters;

    const iconProps = {size: "15", wrapperColor: theme.colors.primary, wrapperSize: "15.5"};

    const clickHandler = () => {
        const url = appendQueryString(rpAppLink.propertyConfigurator(), {
            ...userPreferencesFilters,
            ...(userPreferencesFilters?.region ? {search: userPreferencesFilters?.region} : {}),
            price_1: filterPrice
        });

        creditOfferLeadTracking(CreditTrackingActionType.CLICK);

        window.location.href = url;
    };

    useEffect(() => {
        creditOfferLeadTracking(CreditTrackingActionType.VIEW);
    }, []);

    return (
        <Container as="section" css={boxWrapper}>
            <Row css={rowStyle}>
                <Col md={9}>
                    <Row css={boxContent}>
                        <Col md={3} lg={3} css={iconCol}>
                            <BrandBuildingsIcon {...iconProps} />
                        </Col>
                        <Col>
                            <Text variant="body_copy_1" css={[textAligment]}>
                                RATA
                            </Text>
                            <Text variant="headline_2" css={[textAligment, priceRange]} as="p">
                                {min} - {max} zł
                            </Text>
                            <Text variant="headline_6" css={[textAligment, copyStyle]} as="p">
                                Sprawdź nieruchomości, które mieszczą się w Twojej estymowanej racie kredytu
                            </Text>
                        </Col>
                    </Row>
                </Col>
                <Col md={3} css={colCta}>
                    <Button css={boxCta} variant="filled_primary" onClick={clickHandler}>
                        Zobacz Oferty
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

const priceRange = (theme: Theme) => css`
    background: ${theme.colors.primary};
    width: fit-content;
    margin: 0 auto;
    @media (min-width: ${theme.breakpoints.md}) {
        margin: 0;
    }
`;

const copyStyle = (theme: Theme) => css`
    max-width: 415px;
    margin: 2.4rem auto;
    @media (min-width: ${theme.breakpoints.md}) {
        margin: 2.4rem 0;
    }
`;

const textAligment = css`
    ${textAlign("center")};
    ${onDesktop(textAlign("left"))};
`;

const colCta = css`
    display: flex;
    align-items: center;
    justify-content: end;
`;

const boxCta = (theme: Theme) => css`
    display: block;
    margin: 2rem auto;
    width: 100%;
    @media (min-width: ${theme.breakpoints.md}) {
        width: auto;
        margin: 0;
    }
`;

const boxWrapper = (theme: Theme) => css`
    ${backgroundColor(theme.colors.success)};
    ${w100};
    ${p(2)};
    ${borderRadius(2)};
    box-shadow: ${theme.shadow["2"]};
    ${onDesktop(p(3))};
`;

const iconCol = (theme: Theme) => css`
    ${flexAbsoluteCenter}
    ${p(2)};
    @media (min-width: ${theme.breakpoints.md}) {
        ${flex()}
    }
`;

const rowStyle = (theme: Theme) => css`
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;
const boxContent = (theme: Theme) => css`
    ${flex("center", "space-between")};
    flex-direction: column;

    @media (min-width: ${theme.breakpoints.md}) {
        flex-direction: row;
    }
`;
